import { components } from "react-select";
import { LiaSearchSolid } from "react-icons/lia";

import {
  FIRST_ARRAY_INDEX,
  SINGLE_ARRAY_LENGTH,
  multiSelectLabels,
} from "../../../constants";

const { TOTAL_SELECTED, SELECTED } = multiSelectLabels;

export const formatMultiSelectValues = (
  values,
  { useSingleLabel = false, selectedPrefix = TOTAL_SELECTED } = {}
) => {
  if (!Array.isArray(values)) {
    return values;
  }

  const { length } = values;

  if (useSingleLabel && length === SINGLE_ARRAY_LENGTH) {
    return `${values[FIRST_ARRAY_INDEX].props.children} `;
  }

  return `${selectedPrefix}${length}`;
};

//Customise react select option, add checkbox with every option if we select checkbox enabled
export const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="d-flex align-items-center gap-2">
          <input
            type="checkbox"
            name={props.label}
            checked={props.isSelected}
            readOnly
          />{" "}
          <label className="mb-0 my-auto">{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};

//Customise react select option, add radio with every option if we select radio enabled
export const RadioOption = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="form-check d-flex align-items-center">
          <input
            type="radio"
            id={props.value}
            name={props.label}
            checked={props.isSelected}
            readOnly
            className="form-check-input"
          />
          <label className="form-check-label px-2 mt-1" htmlFor={props.value}>
            {props.label}
          </label>
        </div>
      </components.Option>
    </div>
  );
};

//Function to show label if we select multiple in react select
export const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  values = formatMultiSelectValues(values, {
    useSingleLabel: true,
    selectedPrefix: TOTAL_SELECTED,
  });

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

export const ValueContainerWithSearchIcon = ({ children, ...props }) => {
  return (
    <components.ValueContainer {...props}>
      <div className="d-flex justify-content-start align-items-center w-100">
        <LiaSearchSolid className="me-1" size={17} />
        {children}
      </div>
    </components.ValueContainer>
  );
};

//Function to show label if we select multiple
export const ValueContainerForInbox = ({ children, ...props }) => {
  let [values, input] = children;
  values = formatMultiSelectValues(values, {
    selectedPrefix: SELECTED,
  });

  return (
    <components.ValueContainer {...props}>
      <div className="d-flex flex-column justify-content-center">
        <div className="fw-bold text-secondary">
          {input?.props.selectProps?.name}:
        </div>
        <div className="d-flex align-items-center">
          {values}
          {input}
        </div>
      </div>
    </components.ValueContainer>
  );
};

//Function to show label if we select multiple email in add recipients dropdown
export const reactSelectValContainer = ({ children, ...props }) => {
  let [values, input] = children;
  values = formatMultiSelectValues(values, {
    selectedPrefix: TOTAL_SELECTED,
  });

  return (
    <components.ValueContainer {...props}>
      {values} {input}
    </components.ValueContainer>
  );
};
